import React from 'react';
import { CTAButton } from './CTAButton';
export function ProductSection() {
  return <section id="producto" className="py-16 md:py-24 px-4 bg-forest text-cream relative overflow-hidden scroll-mt-16" data-id="element-447" data-mp="2unjm9zhn3tn">
      {/* Background patterns */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#D4A853 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-448" data-mp="hkurxwvs76gm"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-449" data-mp="qiwy0qudgpar">
        <div className="text-center mb-12" data-id="element-450" data-mp="mid3zw53i1su">
          <span className="inline-block px-4 py-1 rounded-full bg-gold/20 text-gold font-bold tracking-widest uppercase text-sm mb-6 border border-gold/30" data-id="element-451" data-mp="mhl78hzrhy0z">
            Presentando:
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-gold mb-6 drop-shadow-md" data-id="element-452" data-mp="vkcnqw7hvjzh">
            CENAS ANTI-INFLAMATORIAS
            <br data-id="element-453" data-mp="2xaeb8in3glly" />
            EN 15 MINUTOS
          </h2>
          <p className="text-xl md:text-2xl text-cream/90 italic font-serif max-w-3xl mx-auto" data-id="element-454" data-mp="2xbz5s89es4jt">
            El Sistema Completo Para Desinflamar Tu Abdomen Mientras Duermes —
            Con Comida Real, En Solo 15 Minutos Cada Noche
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 mt-16" data-id="element-455" data-mp="5c97nr4cqy40">
          {/* Product Image */}
          <div className="w-full md:w-1/2 relative group" data-id="element-456" data-mp="a3r88e2gqwog">
            <div className="absolute inset-0 bg-gold/30 blur-3xl rounded-full scale-75 group-hover:scale-90 transition-transform duration-700" data-id="element-457" data-mp="a5c88j7jr7tp"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rdHi3rAEoBrUtDvyQN1xfL/mockup_cenas_antiinf15.png" alt="Sistema Cenas Anti-Inflamatorias" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl animate-[float_5s_ease-in-out_infinite]" data-id="element-458" data-mp="k0m9v5u19d6y" />
          </div>

          {/* Description */}
          <div className="w-full md:w-1/2 space-y-6 text-lg text-cream/80" data-id="element-459" data-mp="2qtga7avpufc7">
            <p className="text-xl text-white font-medium" data-id="element-460" data-mp="2usyj18a9izyo">
              Este no es otro recetario de cocina saludable.
            </p>
            <p data-id="element-461" data-mp="1zrtp149q5bs">
              Este es un{' '}
              <strong className="text-gold" data-id="element-462" data-mp="3t5t0gxh7acrm">
                sistema de nutrición nocturna
              </strong>{' '}
              diseñado específicamente para el metabolismo de la mujer de más de
              35 años, basado en los principios de la cronobiología nutricional
              y la medicina anti-inflamatoria.
            </p>
            <p data-id="element-463" data-mp="kwt08qdh0dhu">
              Cada receta, cada combinación de ingredientes, cada especias y
              cada técnica de cocción ha sido seleccionada con un único
              objetivo:
            </p>

            <div className="bg-white/10 p-6 rounded-xl border border-gold/30 backdrop-blur-sm mt-8" data-id="element-464" data-mp="une00h4vro2c">
              <p className="text-xl font-bold text-gold text-center leading-snug" data-id="element-465" data-mp="ppcdfm88x6m4">
                Que tu cuerpo entre en modo reparación profunda en cuanto apoyes
                la cabeza en la almohada.
              </p>
            </div>

            <div className="pt-8" data-id="element-466" data-mp="1ibk8zii1b4og">
              <CTAButton text="VER TODO LO QUE INCLUYE ↓" href="#offer-section" variant="primary" className="bg-gold text-forest hover:bg-gold-light shadow-lg" showTrust={false} data-id="element-467" data-mp="1icc30ovzgucm" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}